import { render, staticRenderFns } from "./TestVideoTipsImgs.vue?vue&type=template&id=bd12d60e&scoped=true&"
import script from "./TestVideoTipsImgs.vue?vue&type=script&lang=js&"
export * from "./TestVideoTipsImgs.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoTipsImgs.vue?vue&type=style&index=0&id=bd12d60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd12d60e",
  null
  
)

export default component.exports